// @ts-nocheck
/* eslint-disable */
import MainDispatcher from '../support/MainDispatcher';
import store from './Store';

var _account = {},
  _errors = {},
  _loading = false;

var AccountStore = store({
  getAccount: function () {
    return _account;
  },
  getErrors: function () {
    return _errors;
  },
  isLoading: function () {
    return _loading;
  },
});

AccountStore.dispatchToken = MainDispatcher.register(function (action) {
  switch (action.action) {
    case 'ACCOUNT_LOADING':
      _loading = true;
      AccountStore.emitChange();
      break;

    case 'ACCOUNT_LOADED':
      _account = action.account;
      _loading = false;
      AccountStore.emitChange();
      break;

    case 'ACCOUNT_ERROR':
      _errors = action.errors;
      AccountStore.emitChange();
      break;
    case 'ACCOUNT_SAVED':
      _loading = false;
      _account = action.account;
      AccountStore.emitChange();
  }
});

export default AccountStore;
